import React from "react";
import { fmtAmount } from "./bookingPricing";

interface Props {
  amount: number;
  currency?: string;
  t: (key: any) => any;
}

const DepositInfoBox: React.FC<Props> = ({ amount, currency, t }) => (
  <div className="pab-deposit-box">
    <div className="pab-deposit-box__title">{t("depositInfo")}</div>
    <div className="pab-deposit-box__row">
      <strong>{t("depositAmount")}</strong> {fmtAmount(Math.round(amount * 0.3), currency)}
    </div>
    <div className="pab-deposit-box__remaining">
      {t("remainingAtCheckIn")} {fmtAmount(amount - Math.round(amount * 0.3), currency)}
    </div>
    <div className="pab-deposit-box__bank">
      <div><strong>{t("recipient")}</strong> Svjetlana Čivčić</div>
      <div><strong>{t("address")}</strong> Ćirpanova 22, Novi Sad</div>
      <div><strong>{t("accountNumber")}</strong> 170-10769564001-14</div>
    </div>
  </div>
);

export default DepositInfoBox;
